import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { defaultLogo } from "../Icons";

const ResourceCard = ({ name = "", image = null, showCheckbox = false, checkbox = null }) => {
  return (
    <div className="resource-card">
      {showCheckbox && <span className="resource-checkbox">{checkbox}</span>}
      <div className="resource-thmub">
        {image ? (
          <img src={image} referrerPolicy="no-referrer" className="resource-img" />
        ) : (
          <span className="default-logo">
            <img src={defaultLogo} referrerPolicy="no-referrer" />
          </span>
        )}
      </div>
      <p className="resource-name">{name}</p>
    </div>
  );
};

export default ResourceCard;
